import { render } from "./CartIcons.vue?vue&type=template&id=3d36bb25"
import script from "./CartIcons.vue?vue&type=script&lang=js"
export * from "./CartIcons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__